import React from 'react';
import { Modifier, ModifierGroup } from 'olo-service/models';
import { ModifierSelector } from '../ModifierSelector/ModifierSelector';
import { useModifiersSelectorState } from './useModifiersSelectorState';

type ModifiersSelectorProps = {
  onChange?: (modifiers: ReadonlyArray<Modifier>) => void;
  groups?: ReadonlyArray<ModifierGroup>;
  value?: ReadonlyArray<Modifier>;
  disabled?: boolean;
};

export const ModifiersSelector: React.FC<ModifiersSelectorProps> = ({
  groups = [], value = [], onChange, disabled
}) => {
  const { modifiers, onSelectorChange } = useModifiersSelectorState(onChange, value);

  return (
    <>
      {groups.map(group => (
        <ModifierSelector
          key={group.id}
          group={group}
          disabled={disabled}
          value={modifiers[group.id]}
          onChange={onSelectorChange}
        />
      ))}
    </>
  );
};
